interface TestimonialCardProps {
  className?: string;
  /** Testimonial quote text */
  quote: string;
  /** Author avatar URL */
  avatar: string;
  /** Author name */
  name: string;
  /** Author role / company */
  role: string;
}

/** Testimonial card (400×268) for «Отзывы» section */
export function TestimonialCard({ className = "", quote, avatar, name, role }: TestimonialCardProps) {
  return (
    <div
      className={`bg-white flex flex-col h-[268px] max-desktop:h-auto max-desktop:min-h-[268px] gap-[24px] items-center justify-between p-[20px] rounded-[16px] w-[400px] max-w-full hover:shadow-[0px_0px_10px_rgba(0,0,0,0.07)] transition-shadow ${className}`}
    >
      {/* Quote */}
      <p
        className="[font-family:var(--font-commissioner)] font-normal not-italic text-[16px] leading-[24px] text-text w-full"
        style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
      >
        {quote}
      </p>

      {/* Author */}
      <div className="flex gap-[16px] items-start w-full shrink-0">
        <img
          src={avatar}
          alt={name}
          className="size-[40px] rounded-full shrink-0 object-cover"
        />
        <div className="flex flex-col gap-[4px] items-start justify-center">
          <span
            className="[font-family:var(--font-commissioner)] font-medium not-italic text-[16px] leading-[20px] text-text"
            style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
          >
            {name}
          </span>
          <span
            className="[font-family:var(--font-commissioner)] font-normal not-italic text-[14px] leading-[16px] text-black"
            style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
          >
            {role}
          </span>
        </div>
      </div>
    </div>
  );
}
